import { render, staticRenderFns } from "./CreditTransactionViewPop.vue?vue&type=template&id=0522f61a"
import script from "./CreditTransactionViewPop.vue?vue&type=script&lang=js"
export * from "./CreditTransactionViewPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0522f61a')) {
      api.createRecord('0522f61a', component.options)
    } else {
      api.reload('0522f61a', component.options)
    }
    module.hot.accept("./CreditTransactionViewPop.vue?vue&type=template&id=0522f61a", function () {
      api.rerender('0522f61a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settle/popup/CreditTransactionViewPop.vue"
export default component.exports